export default __webpack_public_path__ + "static/media/gallery_02.ce804516.jpg";